(function () {
  angular
    .module("akitabox.core.services.associationType", [
      "akitabox.constants",
      "akitabox.core.services.http",
      "akitabox.core.services.organization",
    ])
    .factory("AssociationTypeService", AssociationTypeService);

  /** @ngInject **/
  function AssociationTypeService(models, HttpService, OrganizationService) {
    var service = {
      // Routes
      buildOrganizationBaseRoute: buildOrganizationBaseRoute,
      buildOrganizationDetailRoute: buildOrganizationDetailRoute,
      // Create
      create: create,
      // Update
      update: update,
      // Delete
      remove: remove,
      // Retrieve
      get: get,
      getAll: getAll,
      getById: getById,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /******************* *
     *   Routes
     * ****************** */

    function buildOrganizationBaseRoute(orgId) {
      return (
        OrganizationService.buildDetailRoute(orgId) +
        "/" +
        models.ASSOCIATION_TYPE.ROUTE_PLURAL
      );
    }

    function buildOrganizationDetailRoute(orgId, attachmentId) {
      var base = buildOrganizationBaseRoute(orgId);

      // Attachment detail
      return base + "/" + attachmentId;
    }

    /******************* *
     *   Create
     * ****************** */

    function create(orgId, data, params) {
      var route = buildOrganizationBaseRoute(orgId);
      return HttpService.create(route, data, {}, params);
    }

    /******************* *
     *   Update
     * ****************** */

    function update(orgId, associationTypeId, data) {
      var route = buildOrganizationDetailRoute(orgId, associationTypeId);
      return HttpService.patch(route, data);
    }

    /******************* *
     *   Delete
     * ****************** */

    function remove(orgId, associationTypeId) {
      var route = buildOrganizationDetailRoute(orgId, associationTypeId);
      return HttpService.remove(route);
    }

    /******************* *
     *   Retrieve
     * ****************** */

    function get(orgId, params) {
      var route = buildOrganizationBaseRoute(orgId);
      return HttpService.get(route, params);
    }

    function getAll(orgId, params) {
      var route = buildOrganizationBaseRoute(orgId);
      return HttpService.getAll(route, params);
    }

    function getById(orgId, associationTypeId, params) {
      var route = buildOrganizationDetailRoute(orgId, associationTypeId);
      return HttpService.getById(route, params);
    }
  }
})();
